import Notepad from './Notepad';

export default Notepad;